import React, { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import MediaUtilityService from 'common/services/MediaUtilityService'
import { ThemeColorContext } from 'shared/Components/ItemContent/context'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

function CloudinaryViewer(props) {
  const themeColor = useContext(ThemeColorContext)
  const [player, setPlayer] = useState(null)

  const defaultPlayerOptions = () => {
    return {
      controls: true,
      muted: props.isScheduled,
      ...(!isEmpty(themeColor) && {
        colors: {
          accent: themeColor,
          base: themeColor,
          text: themeColor
        }
      })
    }
  }

  useEffect(() => {
    const playerOptions = props.playerOptions || defaultPlayerOptions()

    MediaUtilityService.generateVideoPlayer(
      props.videoSourceConfig,
      props.playerId,
      playerOptions,
      props.videoTransformation,
      props.startTimeOffset,
      props.closeVideo,
      props.eventMethods,
      props.isScheduled
    ).then(setPlayer)
  }, [])

  useEffect(() => {
    return () => {
      player && player.mute()
    }
  }, [player])

  useEffect(() => {
    if (props.isUserInteracted) {
      player && player.unmute()
    }
  }, [props.isUserInteracted])

  return (
    <div className='cloudinary-video-wrapper'>
      <video
        id={props.playerId}
        className="cld-video-player cld-video-player-skin-dark">
      </video>
    </div>
  )
}

CloudinaryViewer.propTypes = {
  videoSourceConfig: PropTypes.object.isRequired,
  playerId: PropTypes.string.isRequired,
  playerOptions: PropTypes.object,
  videoTransformation: PropTypes.object,
  startTimeOffset: PropTypes.number,
  closeVideo: PropTypes.func,
  eventMethods: PropTypes.object,
  isScheduled: PropTypes.bool,
  isUserInteracted: PropTypes.bool
}

export default CloudinaryViewer
